export const createToggleChangeHandler = <T extends string>(setVisibleTab: (value: T) => void) => {
  return (value: string) => {
    if (value) {
      setVisibleTab(value as T);
    }
  };
};
